import React, { useEffect, useState } from 'react'
import Layout from '../../../components/layouts/Layout'
import { fetchParents } from '../../../store/actions/parentsActions'
import { useDispatch, useSelector } from 'react-redux'
import DataTable from '../../../components/elements/DataTable'
import Loader from '../../../components/elements/Loader'
import { tableHeadersFields } from '../../../utils'
import { useNavigate } from 'react-router-dom'

const Parents = () => {
  const [transactionDialogOpen, setTransactionDialogOpen] = useState(false)
    const [activeDialogTransaction, setActiveDialogTransaction] = useState(null)
    const parentsSelector = useSelector((state => state.parents))
    const dispatch = useDispatch()

    const [perPage, setPerPage] = useState(25)
    const [currentPage, setCurrentPage] = useState(1)

    const updatePerPage = (count) => {
        setPerPage(count)
    }

    const updateCurrentPage = (count) => {
        setCurrentPage(count)
    }

    useEffect (() => {
        dispatch(fetchParents('', currentPage, perPage))
    }, [perPage, currentPage, dispatch])


    const transactionColumnWidths = {
        name: 'w-3/12',
        email: 'w-2/12',
        phoneNumbers: 'w-3/12',
        applications: 'w-1/12',
        students: 'w-1/12',
        origin: 'w-2/12',
    }

    const cleanupData = (dataSet) => {
        const data = []
    
        dataSet.forEach((item, itemIndex) => {
            data.push(
                {
                    name: item.userProfile?.name,
                    email: item.email,
                    phoneNumbers: <p>{item.phone} {item.altPhone && `, ${item.altPhone}`} </p>,
                    applications: item.applications.length,
                    students: item.students.length,
                    origin: <p>{item.origin.lga}, {item.origin.state} - {item.origin.nationality}</p>
                },
            )
        })
    
        return data
    }

    const openTransaction = (transactionIndex) => {
        setTransactionDialogOpen(true)
        setActiveDialogTransaction(transactionIndex)
        console.log(transactionDialogOpen)
        console.log(activeDialogTransaction)
    }

    // const closeTransaction = () => {
    //     setTransactionDialogOpen(false)
    //     setActiveDialogTransaction(null)
    // }
    const navigate = useNavigate()
    const tableOptions = {
        selectable: false,
        clickableRows: true,
        rowAction: (index)=>{navigate(`/admin/parents/parent-profile/${parentsSelector.parents.parents[index]._id}`)}
    }

    const columnDataStyles = {}

    // eslint-disable-next-line no-unused-vars
    const [selectedUsersCount, setSelectedUsersCount] = useState(0)

    const getSelectionCount = (count) => {
        return setSelectedUsersCount(count)
    }


    return (
        <>
            <Layout pageTitle="Parents">
                <div className="w-full">
                    <div className='py-3 mb-5'>
                        <div className="w-full mx-auto">
                            <h4 className='font-medium text-lg mb-3 text-gray-400'>Parents</h4>
                            <div className='w-2/3'>
                                <p className='text-gray-500 my-3 text-sm'>
                                    Below is a list of parents of Vaatia College students
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className=''>
                        {parentsSelector.loadingParents 
                            ? 
                                <div className='w-full'>
                                    <Loader />
                                </div>
                            : 
                                <DataTable
                                    tableHeaders={tableHeadersFields(cleanupData(parentsSelector.parents.parents)[0]).headers} 
                                    tableData={cleanupData(parentsSelector.parents.parents)} 
                                    columnWidths={transactionColumnWidths}
                                    columnDataStyles={columnDataStyles}
                                    allFields={tableHeadersFields(cleanupData(parentsSelector.parents.parents)[0]).fields}
                                    onSelectItems={getSelectionCount}
                                    tableOptions={tableOptions}
                                    pagination={{
                                        perPage, 
                                        currentPage,
                                        totalItems: parentsSelector.parents.total,
                                    }}
                                    changePage={updateCurrentPage}
                                    updatePerPage={updatePerPage}
                                />
                        }
                    </div>
                </div>

            </Layout>

            {/* <Transition appear show={transactionDialogOpen} as={Fragment}> */}
  
        </>
    )

}

export default Parents